module.exports = __webpack_public_path__ + "media/icons/tick-62294970.png";